export const NUMBER_OPERATORS = [
  { label: "=", value: "eq" },
  { label: "≠", value: "neq" },
  { label: ">", value: "gt" },
  { label: "≥", value: "gte" },
  { label: "<", value: "lt" },
  { label: "≤", value: "lte" },
  { label: "between", value: "between" },
];

export function decodeNumberFilter(raw: string) {
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && parsed.op) return parsed;
  } catch {
    /* ignore */
  }
  return { op: "", val: "", min: "", max: "" };
}

export function encodeNumberFilter(
  op: string,
  val: string,
  min: string,
  max: string,
) {
  if (!op) return "";
  if (op === "between") return JSON.stringify({ op, min, max });
  return JSON.stringify({ op, val });
}

export function updateCustomHeaderValues(
  fieldKey: string,
  value: string | string[],
  currentValues: { key: string; value: string | string[] }[],
): { key: string; value: string | string[] }[] {
  const isEmpty = Array.isArray(value) ? value.length === 0 : value === "";
  const existingIndex = currentValues.findIndex((v) => v.key === fieldKey);

  if (isEmpty) {
    return currentValues.filter((v) => v.key !== fieldKey);
  }
  if (existingIndex >= 0) {
    return currentValues.map((v, idx) =>
      idx === existingIndex ? { ...v, value } : v,
    );
  }
  return [...currentValues, { key: fieldKey, value }];
}

export function getBetweenError(min: string, max: string): string | null {
  if (min === "" && max === "") return null;
  if (min === "") return "Min value is required";
  if (max === "") return "Max value is required";
  if (Number(min) > Number(max)) return "Min must be ≤ Max";
  return null;
}

export function updateNumberCustomHeaderValue(
  fieldKey: string,
  op: string,
  val: string,
  min: string,
  max: string,
  currentValues: { key: string; value: string | string[] }[],
): { key: string; value: string | string[] }[] {
  const encoded = encodeNumberFilter(op, val, min, max);
  if (!encoded) {
    return currentValues.filter((v) => v.key !== fieldKey);
  }
  return updateCustomHeaderValues(fieldKey, encoded, currentValues);
}
